import React, { useState, useEffect } from "react";
import { RISK_MEANS, RISK_STEPS } from "components/constants/profileFields";
import { getSingleteam } from "redux-store/care-team/care-team.slice";
import { singleteam } from "redux-store/care-team/care-team.selector";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import LogoPng from "../../assets/images/oncotect-logo.png";

function RiskValue(props: any) {
  return (
    <div className="tw-text-center tw-w-36">
      <div className={`${props.className} tw-rounded-xl tw-text-center tw-mt-10 tw-w-36 tw-h-24 tw-relative`}>
        <div className="tw-text-[16px]">Risk Value</div>
        <div className="tw-text-[40px]">{props.riskValue}</div>
      </div>
      <div
        className={`${props.className} tw-ml-[40%] tw-text-center tw-w-7 tw-h-7 tw-rotate-45 tw-relative -tw-top-4`}
      ></div>
    </div>
  );
}

const VetResult = React.forwardRef((props: any, ref: any) => {
  const [customClassName, setCustomClassName] = useState("");
  const [riskLevelColor, setRiskLevelColor] = useState("");
  const [riskLevel, setRiskLevel] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  // const team = useSelector(singleteam);
  const [team, setTeam] = useState<any>({});
  const [imageData, setImageData] = useState<any>("");

  useEffect(() => {
    if (props.result.riskValue < 0.04) {
      setCustomClassName("tw-justify-start");
      setRiskLevelColor("tw-bg-[#d7f6ff]");
      setRiskLevel("low");
    } else if (props.result.riskValue >= 0.04 && props.result.riskValue < 0.1) {
      setCustomClassName("tw-justify-center");
      setRiskLevelColor("tw-bg-[#FBD881]");
      setRiskLevel("moderate");
    } else if (props.result.riskValue >= 0.1) {
      setCustomClassName("tw-justify-end");
      setRiskLevelColor("tw-bg-[#FF7B6D]");
      setRiskLevel("high");
    }
  }, [props.result.riskValue]);

  useEffect(() => {
    dispatch(getSingleteam(props.result.kitId.careTeams[0])).then((res: any) => {
      if (res.payload.careTeam) {
        setTeam(res.payload.careTeam);
      }
    });
  }, []);

  useEffect(() => {
    // Load the PNG image using fetch
    fetch(LogoPng)
      .then((response) => response.blob())
      .then((blob) => {
        // Convert the blob to a Base64 encoded string
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result;
          setImageData(base64Data);
        };
        reader.readAsDataURL(blob);
      });
  }, []);
  function calculateAgeInMonths(birthdate: any) {
    const today = new Date();
    const birthdateObj = new Date(birthdate);

    // Calculate the difference in years and months
    const yearsDiff = today.getFullYear() - birthdateObj.getFullYear();
    const monthsDiff = today.getMonth() - birthdateObj.getMonth();

    // Convert the years and months difference to months
    const totalMonths = yearsDiff * 12 + monthsDiff;

    return totalMonths;
  }

  return (
    <React.Fragment>
      <div ref={ref} id="vetResult" className="tw-flex tw-w-[1200px] tw-items-center tw-flex-col tw-bg-[#F7F6F4]">
        <img src={`${imageData}`} className="tw-w-36 tw-pt-5" alt="logo" />
        <div className="tw-uppercase tw-text-3xl tw-pt-4">Multi-Cancer Screening Test Results</div>

        <div className="tw-text-[130px]">{props?.result?.petId?.petName || "No Name"}</div>

        <div className="tw-bg-white tw-w-[90%] tw-flex tw-p-4">
          {/* first half */}
          <div>
            <div className="tw-text-3xl tw-font-[700]">Cancer Risk Level</div>
            <div
              className={`tw-rounded ${riskLevelColor} tw-capitalize tw-text-[46px] tw-mt-5 tw-w-[100%] tw-h-16 tw-flex tw-justify-center tw-items-center`}
            >
              {riskLevel}
            </div>
            <div className="tw-h-1 tw-bg-[#E3E3E3] tw-w-[100%] tw-mt-5"></div>

            <div className="tw-text-3xl tw-font-bold tw-mt-5">Cancer Risk Value</div>
            <div className={`tw-w-[480px] tw-flex ${customClassName}`}>
              <RiskValue riskValue={props.result.riskValue} className={riskLevelColor} />
            </div>
            <div className="tw-w-[480px] tw-text-[26px]">
              <div className="tw-inline-block tw-rounded tw-bg-[#d7f6ff] tw-text-center tw-mt-10 tw-w-[156px] tw-h-12 tw-ml-1">
                Low
              </div>
              <div className="tw-inline-block tw-rounded tw-bg-[#FBD881] tw-text-center tw-mt-10 tw-w-[156px] tw-h-12 tw-ml-1">
                Moderate
              </div>
              <div className="tw-inline-block tw-rounded tw-bg-[#FF7B6D] tw-text-center tw-mt-10 tw-w-[156px] tw-h-12 tw-ml-1">
                High
              </div>
              <div className="tw-text-base">
                <div className="tw-inline-block tw-w-[154px]">-0.3</div>
                <div className="tw-inline-block tw-w-[154px]">.04</div>
                <div className="tw-inline-block tw-w-[154px]">.1</div>
                <div className="tw-inline-block ">.3</div>
              </div>
            </div>
          </div>

          {/* second half */}
          <div className="tw-w-2 tw-inline-block inlin tw-bg-[#E3E3E3] tw-ml-14 tw-mt-5">
            <div className="tw-h-[90%]"></div>
          </div>

          {/* 3rd half */}
          <div>
            <div className="tw-pl-[8%]">
              <div className="tw-text-[1.2rem] tw-font-bold tw-uppercase">What does {riskLevel} risk mean?</div>
              <ul className="tw-list-disc tw-pl-5 tw-py-1 tw-text-sm tw-w-[95%]">
                {riskLevel === "low" && RISK_MEANS[0].low}
                {riskLevel === "moderate" && RISK_MEANS[0].moderate}
                {riskLevel === "high" && RISK_MEANS[0].high}
              </ul>
              <div className="tw-text-[1.2rem] tw-font-bold">Next Steps</div>
              <ul className="tw-list-disc tw-pl-5 tw-py-1 tw-text-sm tw-w-[95%]">
                {riskLevel === "low" && RISK_STEPS[0].low}
                {riskLevel === "moderate" && RISK_STEPS[0].moderate}
                {riskLevel === "high" && RISK_STEPS[0].high}
              </ul>
            </div>
          </div>
        </div>

        {/* -------------- */}
        <div className="tw-bg-white tw-w-[90%] tw-flex tw-justify-between tw-mt-5 tw-p-4">
          <div className="tw-flex tw-flex-col tw-w-[70%] tw-pr-10">
            <div className="tw-text-[28px] tw-font-bold tw-pb-5 tw-border-b-2 tw-border-b-[#E3E3E3]">Pet Details</div>

            <div className="tw-flex tw-justify-between tw-flex-wrap tw-items-center">
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">PATIENT NAME</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props?.result?.petId?.petName || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">GENDER</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props.result.petId.petGender || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">PET'S PARENT NAME</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {props.result.userId.fullName || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">AGE</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {calculateAgeInMonths(props.result.petId.birthDate) === 0
                      ? "Less than 1 Month"
                      : calculateAgeInMonths(props.result.petId.birthDate) + " month's" || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">SPECIES</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{props.result.petId.petType || "None"}</div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">HOSPITAL</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{(team && team.hospitalName) || "None"}</div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[14px] tw-uppercase tw-font-medium tw-w-32">BREED</label>
                <div className="tw-inline-block tw-w-52 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">{props.result.petId.petBreed || "None"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* second half */}
          <div className="tw-flex tw-flex-col tw-w-[30%] tw-pl-1">
            <div className="tw-text-[28px] tw-font-bold tw-pb-5 tw-border-b-2 tw-border-b-[#E3E3E3]">Order Info</div>
            <div className="tw-flex tw-justify-between tw-flex-wrap tw-gap-2 tw-items-center">
              <div className="tw-pt-2">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-36">ORDER NUMBER</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center tw-text-[10px]">
                    {props.result.kitId._id || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-36">SAMPLE RECEIVED</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {new Date(props.result.createdAt).toLocaleDateString().toString() || "None"}
                  </div>
                </div>
              </div>
              <div className="tw-pt-2">
                <label className="tw-text-[16px] tw-uppercase tw-font-medium tw-w-36">RESULT REPORTED</label>
                <div className="tw-inline-block tw-w-40 tw-border-2">
                  <div className="tw-h-10 tw-pl-2 tw-flex tw-items-center">
                    {new Date(props.result.updatedAt).toLocaleDateString().toString() || "None"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-mt-2">
          <div className="tw-align-middle">
            <img src={`${imageData}`} className="tw-inline-block tw-w-20 tw-pb-[30px]" alt="logo" />
            <div className="tw-text-6xl tw-inline-block tw-pr-5 tw-border-r-4 tw-border-r-[#afafaf]">oncotect</div>
            <div className="tw-text-[18px] tw-font-bold tw-w-80 tw-uppercase tw-inline-block tw-pl-5">
              accessible early cancer screening tests for dogs
            </div>
          </div>
        </div>
        <div className="tw-mt-[2px] tw-w-[95%]">
          <div className="tw-font-bold tw-text">Important Disclosure on Oncotect Test Results</div>
          <p className="tw-mt-1 tw-mb-1 tw-text">
            Please be advised that the early screening test results provided by Oncotect are not intended to serve as a
            definitive diagnosis. Oncotect is a risk assessment tool based on clinical studies of four cancer types
            (lymphoma, hemangiosarcoma, mast cell tumor, and melanoma) and is designed to evaluate the risk of cancer at
            the time the test was performed. A "low risk" test result does not guarantee the absence of cancer, while a
            "moderate" or "high cancer risk" result does not conclusively confirm the presence of cancer. It is crucial
            for pet owners not to rely solely on the results of Oncotect for diagnostic purposes, but instead to consult
            with their veterinarian for proper interpretation and guidance. Further testing and/or examination may be
            recommended by the veterinarian to obtain a more accurate assessment of your pet's health. By using
            Oncotect, you acknowledge and understand the limitations of the test and agree that the company providing
            the Oncotect test shall not be held liable for any misinterpretation or reliance on the test results without
            the advice of a qualified veterinarian.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              rowGap: "3rem",
            }}
            className="faq-page-1"
          >
            <div className="report-header">
              <img src={`${imageData}`} className="tw-w-36 tw-pt-5 tw-mx-auto" alt="logo" />
              <div className="tw-uppercase tw-text-3xl tw-pt-4">Multi-Cancer Screening Test Results</div>
            </div>
            <div
              style={{
                padding: "3rem",
                background: "#ffffff",
                display: "flex",
                flexDirection: "column",
                rowGap: "0.5rem",
                margin: "0 4rem",
                border: "1px solid #E3E3E3",
                borderRadius: "0.7rem",
              }}
              className="faqs tw-rounded-md"
            >
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  What is the Oncotect test?
                </div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  The Oncotect test is a cutting-edge cancer screening solution for dogs. The test identifies the
                  presence of cancer-associated volatile metabolites at the time of urine collection, providing
                  veterinary professionals and pet owners with the information they need to make informed decisions
                  about their pet's health.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  Can the Oncotect test detect specific types of cancer?
                </div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  The test results are presented as three levels of cancer risk: low, moderate, or high. It is important
                  to note that while the test provides an indication of cancer risk, it does not diagnose a specific
                  type of cancer. Further diagnostic tests and evaluations by a veterinarian are necessary to determine
                  the type and extent of cancer in a dog with a positive result.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  How accurate is the Oncotect test?
                </div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  The Oncotect test has been clinically proven to be highly accurate in detecting the presence of
                  cancer-related volatile metabolites in dogs. With a sensitivity (correctly identifying cancer is
                  present) of 83% and a specificity (correctly confirming the absence of cancer) of 96% among the four
                  most common canine cancer types (melanoma, lymphoma, mast cell tumor, and hemangiosarcoma), the
                  Oncotect test offers a level of accuracy that is on par with or better than other available cancer
                  screening tests for dogs.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  How early can the test screen cancer risk?
                </div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  The Oncotect test offers a unique advantage by allowing for the early detection of cancer risks, even
                  before any clinical signs are noticeable.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  Do early diagnosis of cancer help with effective treatment?
                </div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  Delayed cancer diagnosis can have serious consequences, including a reduced survival rate and
                  increased treatment complications. By detecting cancer early, the Oncotect test provides a crucial
                  opportunity for effective and timely action. Early cancer diagnosis can lead to a wider range of
                  treatment options, improved quality of life, and better health outcomes for dogs.
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "10rem",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              rowGap: "3rem",
            }}
            className="faq-page-2"
          >
            <div className="report-header">
              <img src={`${imageData}`} className="tw-w-36 tw-pt-5 tw-mx-auto" alt="logo" />
              <div className="tw-uppercase tw-text-3xl tw-pt-4 ">Multi-Cancer Screening Test Results</div>
            </div>
            <div
              style={{
                padding: "3rem",
                background: "#ffffff",
                display: "flex",
                flexDirection: "column",
                rowGap: "0.5rem",
                border: "1px solid #E3E3E3",
                borderRadius: "0.7rem",
              }}
              className="faqs"
            >
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  What are the clinical signs of cancer in dogs?
                </div>
                <div
                  style={{
                    fontSize: "1.3rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  <div>
                    Clinical signs of cancer in dogs can vary depending on the type and location of the cancer, but some
                    common signs include
                  </div>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "4rem",
                      margin: "1rem 0",
                      width: "80%",
                    }}
                  >
                    <div>
                      Lumps or masses under the skin Sores that do not heal Changes in behavior or activity level
                      Changes in eating or drinking habits Lameness or stiffness
                    </div>
                    <div>
                      Abnormal swelling or growth Loss of appetite or sudden weight loss Persistent coughing or trouble
                      breathing Difficulty urinating or defecating Bleeding or discharge from body
                    </div>
                  </div>
                  <div>
                    It is important to note that these signs can also be indicative of other health problems and not
                    necessarily cancer. It is always best to consult a veterinarian if you notice any changes in your
                    dog's behavior or health.
                  </div>
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  If the test results shows low risk, what are the next steps?
                </div>
                <div
                  style={{
                    fontSize: "1.3rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  If the results of the Oncotect test indicate low cancer risk, it is a positive sign that the test is
                  detecting low levels of cancerous volatile metabolites among the 4 cancers. This is a cause for relief
                  and peace of mind for pet owners. To maintain ongoing monitoring of your dog's health, we recommend
                  repeating the Oncotect test annually as part of a wellness check. Annual or bi-annual screening test
                  can help to detect any changes in cancer risk over time and ensure that any necessary treatments are
                  started as early as possible.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  If the test results shows moderate risk, what are the next steps?
                </div>
                <div
                  style={{
                    fontSize: "1.3rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  If the Oncotect test results indicate moderate cancer risk, it means that moderate levels of
                  cancerassociated volatile metabolites have been detected in your dog's urine. In such cases, it is
                  important to closely monitor your dog's health and consider additional diagnostic tests. If there are
                  no other clinical signs of cancer, we recommend repeating the Oncotect test in three months to closely
                  monitor any changes in cancer risk or talk to your veterinarian for further testing recommendations.
                  If there are other clinical signs of cancer, it is imperative to take your dog to a veterinarian for
                  additional diagnostic tests such as x-rays or ultrasounds to confirm or rule out the presence of
                  cancer.
                </div>
              </div>
              <div className="faq">
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "600",
                    color: "#29223D",
                  }}
                  className="questinon"
                >
                  If the test results shows high risk, what are the next steps?
                </div>
                <div
                  style={{
                    fontSize: "1.3rem",
                    color: "#29223D",
                  }}
                  className="ansewer"
                >
                  If the Oncotect test results indicate high cancer risk, it indicates the presence of elevated levels
                  of cancerassociated volatile metabolites in your dog's urine. In such cases, it is important to take
                  prompt action to determine the presence of cancer and begin treatment as early as possible. We
                  strongly recommend taking your dog to a veterinarian for additional diagnostic tests such as x-rays or
                  ultrasounds to confirm or rule out the suspicion of cancer. Early detection and prompt action can
                  greatly improve the chances of successful treatment and a positive outcome for your dog.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

export default VetResult;
